import FormattedText from './FormattedText';
import React from 'react';
import { MdEdit, MdDelete, MdSettings } from 'react-icons/md';
import { can } from '../../../permissions';
import ResponsiveTable from '../../ReusableComponents/ResponsiveTable';
import ConfirmButton from './ConfirmButton';
import PortalButton from './PortalButton';
import { usePortalMutation, usePortal, usePortalContext } from '../hooks';
import { ErrorNotice, Status, Loading, Empty } from './Feedback';

export default function PositionManager({ selection, onEdit }) {
  const { user, labels } = usePortal();
  const context = usePortalContext();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const remove = usePortalMutation(
    (data) => `selecoes/${selection.id}/cargos/${data.id}`,
    'DELETE'
  );
  const sources =
    context.data?.processes?.filter(
      (source) => Number(source.faculdade_id) === Number(selection.ontest_faculdade_id)
    ) || [];
  const rows = sources.map((source) => ({
    source,
    portal: selection.positions.find(
      (position) => Number(position.ontest_processo_id) === Number(source.id)
    ),
  }));
  selection.positions
    .filter(
      (position) =>
        !sources.some((source) => Number(source.id) === Number(position.ontest_processo_id))
    )
    .forEach((portal) => rows.push({ portal, source: null }));
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="module-content-heading">
          <h2>{labels.positions}</h2>
          <p>Configure a publicação e a habilitação na linha da opção desejada.</p>
        </div>
        <ErrorNotice error={context.error || remove.error} />
        {context.isLoading ? (
          <Loading />
        ) : !rows.length ? (
          <Empty>Nenhuma opção cadastrada na OnTest.</Empty>
        ) : (
          <ResponsiveTable className="table table-striped">
            <thead>
              <tr>
                <th>{labels.position}</th>
                <th>Publicação no portal</th>
                <th>Inscrição na OnTest</th>
                <th className="hidethis">Ações</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(({ source, portal }) => (
                <tr key={source?.id || portal.id}>
                  <td><FormattedText>{portal?.title || source.name}</FormattedText></td>
                  <td>
                    <Status value={portal?.published ? 'published' : 'draft'} />
                  </td>
                  <td>
                    <Status value={source?.portal_position_enabled ? 'enabled' : 'disabled'} />
                  </td>
                  <td className="hidethis">
                    <div className="portal-admin-actions actions-group">
                      <PortalButton
                        title={`${
                          portal ? 'Editar' : 'Configurar'
                        } ${labels.position.toLowerCase()}`}
                        className="btn btn-sm btn-primary"
                        disabled={!allowed || !source}
                        onClick={() => onEdit({ source, portal })}
                      >
                        {portal ? <MdEdit /> : <MdSettings />}
                      </PortalButton>
                      {portal && (
                        <ConfirmButton
                          title={`Excluir ${labels.position.toLowerCase()}`}
                          className="btn btn-sm btn-danger"
                          disabled={!remove.allowed || remove.isLoading}
                          message="Retirar esta opção do portal?"
                          onConfirm={() => remove.mutate({ id: portal.id })}
                        >
                          <MdDelete />
                        </ConfirmButton>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        )}
      </div>
    </section>
  );
}
